/* =========================
   Optimized site scripts
   - Keep functionality, remove duplicates
   - Uses single DOMContentLoaded and load handlers
   ========================= */
(function () {
    'use strict';

    /* ---------- Helpers ---------- */
    function fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': `application/${type}`
            }
        };
    }

    function safeQuery(selector, root = document) {
        return root.querySelector(selector);
    }

    function safeQueryAll(selector, root = document) {
        return Array.from(root.querySelectorAll(selector || []));
    }

    function on(el, ev, selOrHandler, handlerIfDelegation) {
        // simple delegation helper:
        if (typeof selOrHandler === 'function') {
            el.addEventListener(ev, selOrHandler);
        } else {
            el.addEventListener(ev, function (e) {
                const target = e.target.closest(selOrHandler);
                if (target && el.contains(target)) handlerIfDelegation.call(target, e);
            });
        }
    }

    function debounce(fn, wait) {
        let t;
        return function () {
            clearTimeout(t);
            const args = arguments;
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    function copyToClipboard(text) {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text);
                return;
            }
        } catch (e) {
            // fallback
        }
        const tmp = document.createElement('input');
        tmp.value = text;
        document.body.appendChild(tmp);
        tmp.select();
        tmp.setSelectionRange(0, 99999);
        document.execCommand('copy');
        tmp.remove();
    }

    function isTouch() {
        return ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    }

    /* ---------- Run on window load (for anchor after form submission) ---------- */
    window.addEventListener('load', function () {
        if (window.location.href.includes('customer_posted=true')) {
            const el = safeQuery('#subscribe-form-success');
            if (el) {
                const yOffset = -400;
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }
    });

    /* ---------- Main init on DOMContentLoaded ---------- */
    document.addEventListener('DOMContentLoaded', function () {

        /* ========= CART & ICON ========= */
        function updateCartCountFromJson() {
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    const desktopCount = safeQuery('.menu_carts .count');
                    const mobileCount = safeQuery('.mobile_menu-carts .count');
                    if (desktopCount) desktopCount.textContent = cart.item_count;
                    if (mobileCount) mobileCount.textContent = cart.item_count;

                    const cartIcon = safeQuery('[data-cart-icon]');
                    if (cartIcon) {
                        let b = cartIcon.querySelector('b');
                        if (cart.item_count > 0) {
                            if (!b) {
                                b = document.createElement('b');
                                cartIcon.appendChild(b);
                            }
                            b.innerText = `(${cart.item_count})`;
                        } else if (b) {
                            b.remove();
                        }
                    }
                })
                .catch(e => console.error('updateCartCount error', e));
        }

        // expose small API if needed elsewhere
        window.themeHelpers = window.themeHelpers || {};
        window.themeHelpers.updateCartCount = updateCartCountFromJson;

        /* ========= QUANTITY UI ========= */
        function initQuantityInputs() {
            // keep jQuery usage for .count_input elements if jQuery exists, else fallback
            if (window.jQuery) {
                $('.count_input').each(function () {
                    const $wrap = $(this);
                    const $input = $wrap.find('input');
                    const $dec = $wrap.find('.count_input-dec');
                    const $inc = $wrap.find('.count_input-inc');

                    function setVal(v) { $input.attr('value', Math.max(0, Math.floor(v))); }

                    function inc() { setVal(+$input.attr('value') + 1); }
                    function dec() { setVal(+$input.attr('value') - 1); }

                    $dec.on('click keydown', function (e) {
                        if (e.type === 'click' || e.keyCode === 13) dec();
                    });
                    $inc.on('click keydown', function (e) {
                        if (e.type === 'click' || e.keyCode === 13) inc();
                    });
                });
            } else {
                // fallback for non-jQuery environment
                safeQueryAll('.count_input').forEach(wrap => {
                    const input = wrap.querySelector('input');
                    const dec = wrap.querySelector('.count_input-dec');
                    const inc = wrap.querySelector('.count_input-inc');
                    if (!input) return;
                    const getVal = () => Math.max(0, Number(input.value || input.getAttribute('value') || 0));
                    const setVal = v => {
                        input.value = v;
                        input.setAttribute('value', v);
                    };
                    if (dec) on(dec, 'click', () => setVal(getVal() - 1));
                    if (inc) on(inc, 'click', () => setVal(getVal() + 1));
                });
            }
        }
        initQuantityInputs();

        /* ========= LOCALIZATION SELECT (currency / language) ========= */
        on(document, 'change', '.shopify-localization-form select', function (e) {
            this.form.submit();
        });

        /* ========= COPY TO CLIPBOARD ========= */
        on(document, 'click', '[data-copy]', function (e) {
            e.preventDefault();
            const url = this.getAttribute('data-url') || this.dataset.url;
            if (url) copyToClipboard(url);
        });

        /* ========= SEARCH (mobile header search + debounce) ========= */
        (function initSearchModule() {
            const mobileHeaderSearch = safeQuery('.mobile_header-search');
            if (!mobileHeaderSearch) return;

            const form = mobileHeaderSearch.querySelector('form');
            const searchInput = mobileHeaderSearch.querySelector('[name="q"]');
            const masonryGrid = mobileHeaderSearch.querySelector('.masonry_grid');
            const searchResultContainer = mobileHeaderSearch.querySelector('.mobile_header-search-result');

            const performSearch = debounce(function () {
                if (!form) return;
                const formAction = new URL(form.getAttribute('action') || '/', window.location.origin);
                const formData = new FormData(form);
                const params = new URLSearchParams(formData).toString();
                const url = `${formAction}?${params}`;

                fetch(url, { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                    .then(res => res.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');

                        // replace masonry items
                        const masonryItems = doc.querySelectorAll('.masonry_init_layout .gallery_card');
                        if (masonryGrid) {
                            masonryGrid.innerHTML = '';
                            masonryItems.forEach(item => {
                                const wrapper = document.createElement('div');
                                wrapper.className = 'masonry_grid-item';
                                wrapper.appendChild(item);
                                masonryGrid.appendChild(wrapper);
                            });
                        }

                        // update results count or similar
                        const newSearchResult = doc.querySelector('.search_page-result span');
                        if (searchResultContainer) {
                            if (newSearchResult) {
                                searchResultContainer.innerHTML = newSearchResult.innerHTML;
                                mobileHeaderSearch.classList.add('searching');
                            } else {
                                searchResultContainer.innerHTML = '';
                                mobileHeaderSearch.classList.remove('searching');
                            }
                        }

                        // re-init other things that might be needed (masonry -> transform to columns)
                        initMasonryTransforms();
                        // init images lazy load and GSAP triggers in result area
                        initDataImages(document);
                        initScrollTriggersForGallery();
                    })
                    .catch(err => console.error('Error fetching search results:', err));
            }, 500);

            if (searchInput) {
                searchInput.addEventListener('input', function (e) {
                    e.stopImmediatePropagation();
                    const parent = searchInput.closest('.form-group');
                    if (parent) parent.classList.toggle('filled', !!searchInput.value);
                    performSearch();
                });
            }
        })();

        /* ========= MASONRY transform & GSAP init helpers ========= */
        function initMasonryTransforms() {
            const grids = document.querySelectorAll('.masonry_init_layout');
            grids.forEach(grid => {
                const cards = grid.querySelectorAll('.gallery_card');
                const cols = window.innerWidth > 1024 ? 3 : 1;
                const list = document.createElement('div');
                list.className = 'masonry_grid';
                list.style.opacity = 0;
                for (let i = 0; i < cols; i++) list.innerHTML += '<div class="col"></div>';
                grid.insertAdjacentElement('afterend', list);
                const listColumns = list.querySelectorAll('.col');
                cards.forEach((card, i) => {
                    const col = (i + cols) % cols;
                    const item = document.createElement('div');
                    item.className = 'masonry_grid-item';
                    item.appendChild(card);
                    listColumns[col].appendChild(item);
                });
                list.style.opacity = 1;
                grid.remove();
            });
        }

        function initDataImages(root = document) {
            /* Lazy-load via IntersectionObserver rather than swapping every data-src at once: loading
               ~134 images (~33MB decoded) crashed Chrome on an iPhone 11. Two tiers, mirroring the
               loader in app.js (see its comment for the 28 Aug measurements): near band 300px swaps at
               normal priority; far band 1600px prefetches at fetchpriority=low so fast flicks land on
               in-flight images without the prefetches starving what is on screen. */
            const imgs = root.querySelectorAll('img[data-src], img[data-srcset]');
            const swapImg = function (img) {
                const pic = img.parentNode;
                if (pic && pic.tagName === 'PICTURE') {
                    pic.querySelectorAll('source[data-srcset]').forEach(function (s) { s.setAttribute('srcset', s.getAttribute('data-srcset')); s.removeAttribute('data-srcset'); });
                }
                img.decoding = 'async'; /* decode off the main thread so mid-scroll arrivals don't jank the frame */
                if (img.getAttribute('data-src')) { img.removeAttribute('src'); img.setAttribute('src', img.getAttribute('data-src')); }
                if (img.getAttribute('data-srcset')) { img.removeAttribute('srcset'); img.setAttribute('srcset', img.getAttribute('data-srcset')); }
                img.onload = function () { img.removeAttribute('data-src'); img.removeAttribute('data-srcset'); };
            };
            root.querySelectorAll('picture > source[data-srcset]').forEach(function (s) {
                const im = s.parentNode.querySelector('img');
                if (im && !im.getAttribute('data-src') && !im.getAttribute('data-srcset')) { s.setAttribute('srcset', s.getAttribute('data-srcset')); s.removeAttribute('data-srcset'); }
            });
            if (!('IntersectionObserver' in window) || !imgs.length) { imgs.forEach(swapImg); return; }
            const io = new IntersectionObserver(function (entries, obs) {
                entries.forEach(function (en) {
                    if (!en.isIntersecting) return;
                    const im = en.target;
                    if (im.getAttribute('data-src') || im.getAttribute('data-srcset')) { swapImg(im); }
                    else if (!im.complete) { im.setAttribute('fetchpriority', 'high'); }
                    obs.unobserve(im);
                });
            }, { rootMargin: '300px 0px' });
            const ioFar = new IntersectionObserver(function (entries, obs) {
                entries.forEach(function (en) {
                    if (!en.isIntersecting) return;
                    const im = en.target;
                    if (im.getAttribute('data-src') || im.getAttribute('data-srcset')) { im.setAttribute('fetchpriority', 'low'); swapImg(im); }
                    obs.unobserve(im);
                });
            }, { rootMargin: '1600px 0px' });
            imgs.forEach(function (img) { io.observe(img); ioFar.observe(img); });
        }

        function initScrollTriggersForGallery() {
            // safe-guard if GSAP/ScrollTrigger not present
            try {
                if (!window.gsap || !window.ScrollTrigger) return;
                const galleryCards = document.querySelectorAll('.shop_gallery .gallery_card');
                galleryCards.forEach(card => {
                    ScrollTrigger.create({
                        trigger: card,
                        start: 'top bottom',
                        scrub: true,
                        once: true,
                        onEnter: () => card.classList.add('animate'),
                        onEnterBack: () => card.classList.add('animate')
                    });
                });
            } catch (e) { /* ignore */ }
        }

        /* ========= Currency styling cleanup (MutationObserver-based) ========= */
        function removeStylesBucks() {
            // Observe addition of .hxoSelectTheme .buckscc-select elements & style tags containing --hxoSelect-color
            const observer = new MutationObserver(mutations => {
                mutations.forEach(m => {
                    if (m.type === 'childList') {
                        // check for .hxoSelectTheme .buckscc-select in body
                        if (document.querySelectorAll('.hxoSelectTheme .buckscc-select').length) {
                            document.querySelectorAll('.hxoSelectTheme .buckscc-select').forEach(el => {
                                el.style.removeProperty('--hxoSelect-color');
                                const bucksBtnArrow = document.querySelector('.bucks__folder-collapse_btn');
                                if (bucksBtnArrow && !bucksBtnArrow.querySelector('.icon')) {
                                    bucksBtnArrow.innerHTML = '<span class="icon icon-chevrons-down"> </span>';
                                }
                            });
                        }
                        // style tags - replace occurrences
                        document.querySelectorAll('style').forEach(style => {
                            if (style.innerHTML.includes('--hxoSelect-color')) {
                                style.innerHTML = style.innerHTML.replace(/--hxoSelect-color:[^;]*;/g, '');
                            }
                        });
                    }
                });
            });
            observer.observe(document.body, { childList: true, subtree: true });
            // run once immediately
            document.querySelectorAll('.hxoSelectTheme .buckscc-select').forEach(el => el.style.removeProperty('--hxoSelect-color'));
            document.querySelectorAll('style').forEach(style => {
                if (style.innerHTML.includes('--hxoSelect-color')) {
                    style.innerHTML = style.innerHTML.replace(/--hxoSelect-color:[^;]*;/g, '');
                }
            });
        }
        // run on load & resize
        removeStylesBucks();
        window.addEventListener('resize', removeStylesBucks);

        /* ========= Custom scroll on sections (about-banner) ========= */
        (function initCustomScroll() {
            const customScrollTo = safeQuery('[data-custom-scroll]');
            if (!customScrollTo) return;
            customScrollTo.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                const num = parseInt(customScrollTo.dataset.customScroll, 10);
                const main = customScrollTo.closest('main');
                if (!main) return;
                const sections = main.querySelectorAll(':scope > *');
                if (sections[num]) sections[num].scrollIntoView({ behavior: 'smooth' });
            });
        })();

        /* ========= Inbox app / Shadow DOM styling ========= */
        (function initInboxStyling() {
            function waitForShadowRoot() {
                const chatComponent = document.querySelector('inbox-online-store-chat');
                if (chatComponent && chatComponent.shadowRoot) {
                    injectNotificationStyle(chatComponent);
                } else {
                    setTimeout(waitForShadowRoot, 300);
                }
            }
            function injectNotificationStyle(chatComponent) {
                const shadow = chatComponent.shadowRoot;
                if (shadow.querySelector('#custom-chat-notification-style')) return;
                const style = document.createElement('style');
                style.id = 'custom-chat-notification-style';
                style.textContent = `.chat-notification{background-color:#2b2b2b !important;color:white !important;}`;
                shadow.appendChild(style);
            }
            waitForShadowRoot();
        })();

        /* ========= Change language flag icons ========= */
        (function initFlags() {
            // If window.languages.flagArray appears later, observe and apply
            function applyFlags() {
                if (!window.languages || !Array.isArray(window.languages.flagArray)) return false;
                let found = false;

                window.languages.flagArray.forEach(flag => {
                    if (flag.iso && flag.url) {
                        const els = document.querySelectorAll('.hxoFlag.hxoFlag-' + flag.iso);
                        if (els.length) found = true;

                        els.forEach(item => {
                            item.style.backgroundImage = `url("${flag.url}")`;
                            item.style.backgroundSize = 'cover';
                            item.style.backgroundPosition = 'center';
                        });
                    }
                });
                
                return found;
            }
            // Try immediate, else observe DOM for changes
            if (!applyFlags()) {
                const mo = new MutationObserver(() => {
                    if (applyFlags()) mo.disconnect();
                });
                mo.observe(document.body, { childList: true, subtree: true });
            }
        })();

        /* ========= Footer spacing tweak ========= */
        (function initFooterSpacing() {
            const footerContentNavigation = safeQuery('.footer_content-navigation');
            const footerAdditionalLeftside = safeQuery('.footer_additional-leftside');
            if (!footerContentNavigation || !footerAdditionalLeftside) return;
            const child1 = footerContentNavigation.children[1];
            const child2 = footerAdditionalLeftside.children[1];
            if (!child1 || !child2) return;
            const left1 = child1.getBoundingClientRect().left;
            const left2 = child2.getBoundingClientRect().left;
            const delta = left1 - left2;
            const computedStyle = window.getComputedStyle(footerAdditionalLeftside);
            const currentGap = parseFloat(computedStyle.gap) || 0;
            footerAdditionalLeftside.style.gap = `${currentGap + delta}px`;
        })();

        /* ========= Hover to show currency (desktop-only) ========= */
        (function initCurrencyHoverDebug() {
            try {
                const isTouchFunc = (typeof isTouch === 'function') ? isTouch : function() {
                    return ('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
                };
                const touch = !!isTouchFunc();
                if (touch) {
                    return;
                }

                function doInit() {
                    const selects = Array.from(document.querySelectorAll('.buckscc-select'));

                    if (!selects.length) {
                        if (!window.__bucksccHoverObserver) {
                            window.__bucksccHoverObserver = new MutationObserver((mutations, obs) => {
                                if (document.querySelector('.buckscc-select')) {
                                    obs.disconnect();
                                    window.__bucksccHoverObserver = null;
                                    doInit();
                                }
                            });
                            window.__bucksccHoverObserver.observe(document.body, { childList: true, subtree: true });
                        }
                        return;
                    }

                    selects.forEach((select, idx) => {
                        if (select.dataset.bucksHoverInitialized) {
                            return;
                        }
                        select.dataset.bucksHoverInitialized = '1';

                        const trigger = select.querySelector('.buckscc-select-styled');
                        const options = select.querySelector('.buckscc-select-options');

                        let hideTimeout = null;

                        function showMenu(e) {
                            if (hideTimeout) {
                                clearTimeout(hideTimeout);
                                hideTimeout = null;
                            }
                            if (trigger) {
                                trigger.classList.add('active');
                                trigger.classList.remove('deactive');
                            }
                            if (options) options.classList.add('active');
                        }

                        function hideMenuDelayed(e) {
                            if (hideTimeout) clearTimeout(hideTimeout);
                            hideTimeout = setTimeout(() => {
                                const stillHover = select.matches(':hover') || (trigger && trigger.matches(':hover')) || (options && options.matches(':hover'));

                                if (!stillHover) {
                                    if (trigger) {
                                        trigger.classList.remove('active');
                                        trigger.classList.add('deactive');
                                    }
                                    if (options) options.classList.remove('active');

                                } else {

                                }
                            }, 300);
                        }

                        select.addEventListener('mouseenter', showMenu);
                        select.addEventListener('mouseleave', hideMenuDelayed);
                        if (trigger) {
                            trigger.addEventListener('mouseenter', showMenu);
                            trigger.addEventListener('mouseleave', hideMenuDelayed);
                        }
                        if (options) {
                            options.addEventListener('mouseenter', showMenu);
                            options.addEventListener('mouseleave', hideMenuDelayed);
                        }
                    });
                }

                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', doInit);
                } else {
                    doInit();
                }
            } catch (err) {
                console.error('[buckscc-hover] init error:', err);
            }
        })();

        /* ========= Custom cursor module (with mutation observer) ========= */
        (function initCustomCursor() {
            const target = safeQuery('#cursor');
            if (!target) return;

            const selectorList = [
                '.buckscc-select-styled',
                '.converterTriggers',
                '.select2-results__option',
                '.tab__title .icon',
                '.tab__container',
                '.discover_all-button',
                '.custom_multyselect-title'
            ];

            function refreshCursorFor(el, reason) {
                const isTab = el.classList && el.classList.contains('tab__container');
                const hasHide = el.classList && el.classList.contains('hide-c');
                let matchesAny = selectorList.some(sel => el.matches?.(sel));

                if (isTab) matchesAny = hasHide; // only when hide-c
                
                if (matchesAny) {
                    target.classList.add('is-link');
                } else {
                    // target.classList.remove('is-link');
                }
                if (reason === 'mouseleave') target.classList.remove('is-link');
            }

            function attachCursorEvents(el) {
                if (el.dataset && el.dataset.cursorBound) return;
                el.addEventListener('mouseenter', () => refreshCursorFor(el, 'mouseenter'));
                el.addEventListener('mouseleave', () => refreshCursorFor(el, 'mouseleave'));
                if (el.dataset) el.dataset.cursorBound = 'true';
            }

            // init on existing elements
            selectorList.forEach(sel => document.querySelectorAll(sel).forEach(attachCursorEvents));

            // observe new nodes / class changes
            const mo = new MutationObserver(muts => {
                muts.forEach(m => {
                    if (m.type === 'childList') {
                        m.addedNodes.forEach(node => {
                            if (node.nodeType === 1) {
                                selectorList.forEach(sel => {
                                    if (node.matches?.(sel)) attachCursorEvents(node);
                                    node.querySelectorAll?.(sel)?.forEach(attachCursorEvents);
                                });
                            }
                        });
                    } else if (m.type === 'attributes' && m.attributeName === 'class' && m.target) {
                        if (m.target.matches(':hover')) refreshCursorFor(m.target, 'attributes(class change)');
                    }
                });
            });
            mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        })();

        /* ========= ShopifyChat shadow handling (cursor tweak) ========= */
        (function initShopifyChatCursor(maxWait = 10000) {
            const start = Date.now();
            function check() {
                const chatEl = document.querySelector('#ShopifyChat');
                const targetCursor = safeQuery('#cursor');
                if (chatEl && chatEl.shadowRoot && targetCursor) {
                    const shadowRoot = chatEl.shadowRoot;
                    const style = document.createElement('style');
                    style.textContent = `*{cursor:none !important;} .chat-app *::selection{color:#ffd081;}`;
                    shadowRoot.appendChild(style);

                    shadowRoot.addEventListener('mouseover', (e) => {
                        const el = e.target;
                        try {
                            if (el.closest('.chat-app>[type="button"]')) targetCursor.classList.add('is-link', 'is-reverse');
                            else if (el.closest('.chat-app>div button, .chat-app input, .chat-app select, .chat-app a, .chat-app label')) targetCursor.classList.add('is-link', 'is-reverse');
                            else if (el.closest('.chat-app .composer-bar__box')) { targetCursor.classList.add('is-link'); targetCursor.classList.remove('is-reverse'); }
                            else if (el.closest('.chat-app>div')) targetCursor.classList.add('is-reverse');
                        } catch (err) { /* ignore */ }
                    });

                    shadowRoot.addEventListener('mouseout', (e) => {
                        const el = e.target;
                        try {
                            if (el.closest('.chat-app>[type="button"]')) targetCursor.classList.remove('is-link', 'is-reverse');
                            else if (el.closest('.chat-app>div button, .chat-app input, .chat-app select, .chat-app a, .chat-app label')) targetCursor.classList.remove('is-link', 'is-reverse');
                            else if (el.closest('.chat-app .composer-bar__box')) targetCursor.classList.remove('is-link');
                            else if (el.closest('.chat-app>div')) {
                                if (!el.closest('.chat-app>div:hover')) targetCursor.classList.remove('is-reverse');
                            }
                        } catch (err) { /* ignore */ }
                    });

                } else if (Date.now() - start < maxWait) {
                    requestAnimationFrame(check);
                } else {
                    console.warn('ShopifyChat or its shadowRoot not found within', maxWait, 'ms');
                }
            }
            check();
        })();

        /* ========= Currency icon hover / flags / minor UI already handled above ========= */

        /* ========= GSAP init functions (run once) ========= */
        initDataImages(document);
        initScrollTriggersForGallery();
        initMasonryTransforms();

        /* ========= Expose some utilities to global if developer needs to call them later ========= */
        window.theme = window.theme || {};
        window.theme.initQuantityInputs = initQuantityInputs;
        window.theme.updateCartCount = updateCartCountFromJson;
        window.theme.initMasonryTransforms = initMasonryTransforms;
        window.theme.initDataImages = initDataImages;

    }); // end DOMContentLoaded

})();
